import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rn-vui/themed';

import {Icon} from '../../Icon';
import Text from '../../themed/Text';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

type SeeAllButtonProps = {
  onPress?: any;
  variant?: 'small';
  text?: string;
  spaceBetween?: boolean;
};

function SeeAllButton({onPress, text, variant, spaceBetween}: SeeAllButtonProps) {
  const styles = useStyles({spaceBetween});

  return (
    <PressableWithOpacityFeedback onPress={onPress}>
      <View style={styles.containerStyle}>
        <Text noMargin style={styles.text} variant={variant !== 'small' && 'heading1'}>
          {text ?? ''}
        </Text>
        <Icon
          name="arrow-right-long"
          size={variant !== 'small' ? 30 : 18}
          color={styles.text.color}
        />
      </View>
    </PressableWithOpacityFeedback>
  );
}

const useStyles = makeStyles((theme, {spaceBetween}: SeeAllButtonProps) => {
  return {
    containerStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
      ...(spaceBetween ? {justifyContent: 'space-between'} : {}),
    },
    text: {
      color: theme.colors.text.heading.primary,
    },
  };
});

export default SeeAllButton;
